import * as Actions from '../index';
import * as TYPES from '../actions';
import { listUserCartItems } from '../../../api/queries'
import { createCartItem, createFreePackage } from '../../../api/mutations'
import { deleteCartItem } from '../../../graphql/mutations';
import { checkout } from '../../../graphql/mutations';
import { verifyCoupon } from '../../../graphql/mutations';
import { API, graphqlOperation } from 'aws-amplify'
import { toast } from 'react-toastify';

const createFreePackageWithCoupon = `
  mutation CreateFreePackage(
    $packageId: ID!
    $userId: ID!
    $quizId: ID!
    $couponCode: String
  ) {
    createFreePackage(
      packageId: $packageId
      userId: $userId
      quizId: $quizId
      couponCode: $couponCode
    )
  }
`;

export const saveCartData = userSubmission => {
    return {
        type: TYPES.CURRENT_USER_CART_DATA,
        data: userSubmission,
    };
};

export const saveCouponResult = userSubmission => {
    return {
        type: TYPES.COUPON_RESULT,
        data: userSubmission,
    };
};

export const dispatchCartItems = (userData) => {
    return dispatch => {
        dispatch({
            type: TYPES.UI_START_LOADING
        });
        try {
            return API.graphql(graphqlOperation(listUserCartItems, { userId: userData })).then((result) => {
                dispatch(Actions.saveCartData(result.data.listUserCartItems.items))
                dispatch({
                    type: TYPES.UI_STOP_LOADING
                });
                return result
            })
        } catch (err) {
            dispatch({
                type: TYPES.UI_STOP_LOADING
            });
            toast.error("Error in dispatch is ", err);
        }
    }
}
export const dispatchAddToCart = (userData, userID) => {
    return dispatch => {
        try {
            dispatch({
                type: TYPES.UI_START_LOADING
            });
            return API.graphql(graphqlOperation(createCartItem, { input: userData })).then((result) => {
                dispatch({
                    type: TYPES.UI_STOP_LOADING
                });
                dispatch(Actions.dispatchCartItems(userID));
                toast.success('Item added to cart');
                return result
            })
        } catch (err) {
            dispatch({
                type: TYPES.UI_STOP_LOADING
            });
            toast.error("Error in dispatch is ", err);
        }
    }
}

export const dispatchDeleteCartItem = (userData, userID) => {
    return dispatch => {
        try {
            dispatch({
                type: TYPES.UI_START_LOADING
            });
            return API.graphql(graphqlOperation(deleteCartItem, { input: userData })).then((result) => {
                dispatch({
                    type: TYPES.UI_STOP_LOADING
                });
                dispatch(Actions.dispatchCartItems(userID));
                toast.success('Item deleted successfully');
                return result
            })
        } catch (err) {
            dispatch({
                type: TYPES.UI_STOP_LOADING
            });
            toast.error("Error in dispatch is ", err);
        }
    }
}
export const dispatchVerifyCoupon = (userData, userID) => {
    return dispatch => {
        try {
            dispatch({
                type: TYPES.UI_START_LOADING
            });
            return API.graphql(graphqlOperation(verifyCoupon, { input: userData })).then((result) => {
                dispatch({
                    type: TYPES.UI_STOP_LOADING
                });
                const parsed = JSON.parse(result.data.verifyCoupon)
                if(parsed.statusCode === 200){
                    dispatch(Actions.saveCouponResult(parsed.body.data));
                    toast.success('Coupon verified successfully');
                } else{
                    toast.error(parsed.body.message);
                }
            })
        } catch (err) {
            dispatch({
                type: TYPES.UI_STOP_LOADING
            });
            toast.error("Error in dispatch is ", err);
        }
    }
}

export const dispatchCheckout = (userData, userID) => {
    return dispatch => {
        try {
            dispatch({
                type: TYPES.UI_START_LOADING
            });
            return API.graphql(graphqlOperation(checkout, { input: userData })).then((result) => {
                dispatch({
                    type: TYPES.UI_STOP_LOADING
                });
                const parsed = JSON.parse(result.data.checkout)
                if(parsed.statusCode === 200){
                    dispatch(saveCartData([]));
                    dispatch(saveCouponResult({}));
                    localStorage.setItem('checkStats', 'afterCheckout')
                    window.open(parsed.body.data.checkoutPageUrl, "_self");
                    return result
                } else{
                    toast.error(parsed.body.message);
                }
            })
        } catch (err) {
            dispatch({
                type: TYPES.UI_STOP_LOADING
            });
            toast.error("Error in dispatch is ", err);
        }
    }
}
export const dispatchCreateFreePackage = (userData, userID) => {
    return dispatch => {
        try {
            dispatch({
                type: TYPES.UI_START_LOADING
            });
            const supportsCouponArg = localStorage.getItem('createFreePackage_supports_couponCode') !== '0';
            const useCoupon = !!userData?.couponCode && supportsCouponArg;
            const doc = useCoupon ? createFreePackageWithCoupon : createFreePackage;

            return API.graphql(graphqlOperation(doc, userData))
                .catch((err) => {
                    const message =
                        err?.errors?.[0]?.message ||
                        err?.message ||
                        '';
                    const isCouponArgUnsupported =
                        message.includes('couponCode') &&
                        (message.includes('UnknownArgument') ||
                            message.includes('Unknown argument') ||
                            message.includes('Unknown argument "couponCode"') ||
                            message.includes('Validation') ||
                            message.includes('Validation error'));

                    if (useCoupon && isCouponArgUnsupported) {
                        localStorage.setItem('createFreePackage_supports_couponCode', '0');
                        const { couponCode, ...rest } = userData;
                        return API.graphql(graphqlOperation(createFreePackage, rest));
                    }
                    throw err;
                })
                .then((result) => {
                    dispatch({
                        type: TYPES.UI_STOP_LOADING
                    });
                    console.log("Result] is ", result)
                })
                .catch((err) => {
                    dispatch({
                        type: TYPES.UI_STOP_LOADING
                    });
                    toast.error(err?.errors?.[0]?.message || err?.message || "Error creating free package");
                })
        } catch (err) {
            dispatch({
                type: TYPES.UI_STOP_LOADING
            });
            toast.error("Error in dispatch is ", err);
        }
    }
}
